import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import InputNumberFunc from "./../../../function/InputNumberFunc";
import { InputCharacterCheck } from "./../../../function/InputCharNumCheckFunc";
import MultipleImageUploadComponent from "../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import SimpleReactLightbox from "simple-react-lightbox";
import Alert from "react-s-alert";
import axios from "axios";
import { serverApi } from "../../../config/Keys";
import { useFormik } from "formik";
import * as yup from "yup";
import { NewInputText } from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import isEmpty from "../../../store/validation/is-Empty";
import { connect } from "react-redux";
import {
  needHelp,
  getInfoVendorByMobile,
  get_vendor_tickets_issue_category_need_help,
} from "../../../store/actions/needHelpAction/needHelpAction";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

const strongRegex = new RegExp(
  /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,32}$/
);

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const mobileNumberRgex = /^[0-9]{10}$/;

const validationSchema = yup.object({
  name: yup
    .string()
    .required("name is required")
    .min(1, "Minimum 1 Character")
    .max(35, "Maximum 35 Character"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  // code: yup.string().matches(/^\+\d+$/i),
  number: yup
    .number()
    .required("Mobile number is required")
    .positive()
    .integer(),
  // .matches(mobileNumberRgex, "Enter valid mobile number"),
  // .max(10, "mobile number not more than 10 characters"),
  title: yup
    .string()
    .required("Title is required")
    .max(50, "Maximum 50 Characters"),
  category: yup.string().required("Category is required"),
  comments: yup
    .string()
    .required("Comment is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  photos: yup.array().min(1),
});

const AddRaiseTicket = (props) => {
  const classes = useStyles();
  //state
  const [state, setState] = useState({
    country_code: "",
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    actionButton: false,
    progress: 0,
    isLoading: false,
    number: "",
    errors: {},
  });
  const handleChangeCode = (event) => {
    setState({
      ...state,
      country_code: event.target.value,
    });
    // formik.setFieldValue("code", event.target.value);
  };

  const [ShowAddIssue, setShowAddIssue] = useState(false);

  const handleShowAddIssue = () => {
    setShowAddIssue(true);
  };
  const handleCloseAddIssue = () => {
    setShowAddIssue(false);
    // alert("")
    formik.setFieldValue("email", "");
    formik.setFieldValue("name", "");
    formik.setFieldValue("number", "");
    setState({
      ...state,
      number: "",
    });
    formik.resetForm();
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik.values.photos;
    let newData = e;
    let mergedData = oldData.concat(newData);
    formik.setFieldValue("photos", mergedData);
    cancelFiles(file);
  };

  const cancelFiles = (file) => {
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };
  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });

    if (formik.values.photos.length + e.target.files.length > 5) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const combined = "HelpRaiseTicket";
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        let allPicures = formik.values.photos;
        allPicures.some((phone) => {
          if (phone.split(`${combined}-`)[1] === e.target.files[i].name) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              let oldData = formik.values.photos;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              formik.setFieldValue("photos", mergedData);
              Alert.success(`<h4>Image Upload Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
    e.target.value = "";
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik.values.photos.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue("photos", allImages);
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  const [vendor, setVendor] = useState({});
  const onDataGetVendor = (data) => {
    formik.setFieldValue("email", data.email);
    formik.setFieldValue("name", data.restaurantName);
    setVendor(data);
  };
  const onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setState({
      ...state,
      [e.target.name]: number,
    });
    onDataGetVendor({});
    formik.setFieldValue("email", "");
    formik.setFieldValue("name", "");
    if (number.toString().length === 10) {
      const country_code = state.country_code;
      props.getInfoVendorByMobile(number, country_code, onDataGetVendor);
    }
    formik.setFieldValue("number", number);
  };

  const onFocusOut = (e) => {
    const { errors } = state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else if (
      e.target.name === "email" &&
      !validEmailRegex.test(e.target.value)
    ) {
      errors[e.target.name] = `A valid email is required!`;
    } else {
      errors[e.target.name] = "";
    }
    setState({
      ...state,
      errors: errors,
    });
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      code: "",
      number: "",
      title: "",
      category: "",
      comments: "",
      photos: [],
    },
    validationSchema,

    onSubmit: (values) => {
      const country_code = state.country_code;
      formik.setFieldValue("code", country_code);
      let formData = {
        name: values.name,
        email: values.email,
        code: values.code,
        number: values.number,
        title: values.title,
        category: values.category,
        comments: values.comments,
        photos: formik.values.photos,
      };
      const dataToSend = {
        ticket_category: 11,
        ticket_sub_category_id: values.category,
        vendorId: vendor._id,
        restaurantId: vendor.restaurantId,
        description: values.comments,
        refrence_images: formik.values.photos,
      };
      props.needHelp(dataToSend, onSuccessHelpSubmit);
      // props.vendor_create_new_events(formData, token, onSuccess);
    },
  });

  const onSuccessHelpSubmit = (succ) => {
    console.log(succ);
    formik.resetForm();
    handleCloseAddIssue();
    Alert.success(`<h4>Successfully raised a ticket</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };
  // const onSubmit = () => {}

  // const onSuccess = (e) => {
  //   history.push("/event");
  // };
  const [cats, setCats] = useState([]);
  const setCategories = (sub_cats) => {
    setCats(sub_cats);
  };
  useEffect(() => {
    props.get_vendor_tickets_issue_category_need_help(setCategories);
  }, []);
  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    formik.setFieldValue("name", "");
  }, []);

  useEffect(() => {
    // if (formik.errors && formik.errors.name) {
    //   let nameElement = document.getElementById("name");
    //   nameElement.focus();
    // } else if (!vendor.email) {
    //   let emailElement = document.getElementById("email");
    //   emailElement.focus();
    // }
    //  else if (formik.errors && formik.errors.code) {
    //   let codeElement = document.getElementById("code");
    //   codeElement.focus();
    // }
    // else
    if (formik.errors && formik.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement && nameElement.focus();
    } else if (formik.errors && formik.errors.number) {
      let numberElement = document.getElementById("number");
      numberElement && numberElement.focus();
    } else if (formik.errors && formik.errors.category) {
      let categoryElement = document.getElementById("category");
      categoryElement && categoryElement.focus();
    } else if (formik.errors && formik.errors.comments) {
      let commentsElement = document.getElementById("comments");
      commentsElement && commentsElement.focus();
    }
  }, [count]);

  useEffect(() => {
    // props.clear_all_errors();
    setState({ ...state, isLoading: true, errors: {} });
    axios
      .get("https://ipapi.co/json")
      .then((result) => {
        setState({
          ...state,
          country_code: result.data.country_calling_code,
          country: result.data.country_code,
          isLoading: false,
        });
        // formik.setFieldValue("code", result.data.country_calling_code);
      })
      .catch((error) =>
        setState({
          ...state,
          error,
          isLoading: false,
        })
      );
  }, []);

  const [mobile_number, setMobile] = useState("");

  // const handleChangeCategory = () => {
  //   formik.setFieldValue("category");
  // };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className={` f16-700 ${
          props.extraClass ? props.extraClass : " p-0 text-red ml-2 "
        }`}
        onClick={handleShowAddIssue}
      >
        Raise A Ticket
      </Button>
      <Modal
        show={ShowAddIssue}
        onHide={handleCloseAddIssue}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header className="border-0 pb-0" closeButton>
          <Modal.Title className="f22-500">Raise a Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={formik.onSubmit}>
            <Row>
              <Col xs={4} className="pr-0">
                <FormControl variant="outlined" className="w-100">
                  <Select
                    value={state.country_code}
                    onChange={handleChangeCode}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value={state.country_code}>
                      {state.country_code}
                    </MenuItem>
                    {getCountries().map((country) => (
                      <MenuItem
                        key={country}
                        data-countryCode={country}
                        value={"+" + getCountryCallingCode(country)}
                      >
                        {en[country]} (+
                        {getCountryCallingCode(country)})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Col>
              <Col xs={8}>
                <Form.Group>
                  <NewInputText
                    extraClass="mb-0"
                    name="number"
                    inputType="number"
                    onFocusOut={onFocusOut}
                    onChange={onChange}
                    onKeyDown={InputNumberFunc}
                    value={state.number}
                    maxLength="10"
                    errorText={
                      formik.values.number.length > 0 &&
                      formik.values.number.length <= 9
                        ? "Enter valid Mobile Number"
                        : null
                    }
                    errorTrue={
                      formik.values.number.length > 0 &&
                      formik.values.number.length <= 9
                        ? true
                        : false
                    }
                    labelText="Phone Number"
                    controlClass={
                      formik.values.number.length > 0 &&
                      formik.values.number.length <= 9
                        ? "outlined-error-helper-text"
                        : "outlined-helperText"
                    }
                  />
                  {formik.errors.number && formik.touched.number ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.number}
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <TextField
                    id="name"
                    label="Name"
                    type="text"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.name && formik.touched.name ? "enError" : ""
                    }`}
                    name="name"
                    onChange={formik.handleChange}
                    onKeyDown={InputCharacterCheck}
                    inputProps={{ maxLength: 60 }}
                    value={formik.values.name}
                    onBlur={formik.handleBlur}
                    disabled
                  />
                  {formik.errors.name && formik.touched.name ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.name}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group>
                  <TextField
                    id="email"
                    label="Email"
                    type="email"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.email && formik.touched.email
                        ? "enError"
                        : ""
                    }`}
                    name="email"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                    disabled
                  />
                  {formik.errors.email && formik.touched.email ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.email}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group>
                  <TextField
                    id="title"
                    label="Title"
                    type="text"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.title && formik.touched.title
                        ? "enError"
                        : ""
                    }`}
                    name="title"
                    onChange={formik.handleChange}
                    value={formik.values.title}
                    onBlur={formik.handleBlur}
                    onFocusOut={onFocusOut}
                  />
                  {formik.errors.title && formik.touched.title ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.title}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-Category">
                      Category
                    </InputLabel>
                    <Select
                      value={formik.values.category}
                      onChange={formik.handleChange}
                      label="Category"
                      inputProps={{
                        name: "category",
                        id: "category",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {cats.map((data, index) => {
                        return (
                          <MenuItem value={data._id} key={index}>
                            {data.title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {formik.errors.category && formik.touched.category ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.category}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group>
                  <TextField
                    id="comments"
                    label="Comments"
                    type="text"
                    multiline
                    rows="5"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.comments && formik.touched.comments
                        ? "enError"
                        : ""
                    }`}
                    name="comments"
                    onChange={formik.handleChange}
                    value={formik.values.comments}
                    onBlur={formik.handleBlur}
                    onFocusOut={onFocusOut}
                  />
                  {formik.errors.comments && formik.touched.comments ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.comments}
                    </div>
                  ) : null}
                </Form.Group>
                {/* <Form.Group>
                  <div className="event-offer-image"> */}
                <SimpleReactLightbox>
                  <MultipleImageUploadComponent
                    title="Add Attachment"
                    onChange={bankUploadMultipleFiles}
                    //stateValue={bank_informaion}
                    stateValue={formik.values.photos}
                    newUploaded={
                      restaurant_pictures_new ? restaurant_pictures_new : []
                    }
                    combined={combined}
                    onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
                    cancelFiles={cancelFiles}
                    removeImage={bankDocMultipleRemove}
                    accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                    // loader={state.bankImageLoader}
                  />
                </SimpleReactLightbox>
                {/* </div> */}
                {formik.errors.photos && formik.touched.photos ? (
                  <div className="mb-3 pho_14_regular text-danger">
                    {formik.errors.photos}
                  </div>
                ) : (
                  <div className="mb-3"> </div>
                )}
                <div className="f12-400">
                  (You can upload maximum 5 attachments per ticket in .jpg,
                  .jpeg, .png format)
                </div>
                {/* </Form.Group> */}
              </Col>
              <Col md={12}>
                <div className="pt-4 d-flex align-items-center">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5 "
                    onClick={handleCloseAddIssue}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    type="submit"
                    className="btn150px btn-lg px-5"
                    onClick={(e) => onClickSave(e)}
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

// export default AddRaiseTicket;

AddRaiseTicket.propTypes = {};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  needHelp,
  getInfoVendorByMobile,
  get_vendor_tickets_issue_category_need_help,
})(AddRaiseTicket);
